import React, { useEffect, useRef } from "react";
import { BrowserMultiFormatReader } from "@zxing/library";
import styles from "./QrScanner.module.css";

/**
 * Multi-Format Scanner Component (QR, Barcode, Data Matrix)
 * @param {Function} onScan - Callback when a code is successfully scanned.
 * @param {Function} onError - Callback when an error occurs.
 */
const QrScanner = ({
  onScan,
  onError,
  facingMode = "environment",
  setStreamParent,
}) => {
  const videoRef = useRef(null);
  const codeReader = useRef(new BrowserMultiFormatReader());

  useEffect(() => {
    const reader = codeReader.current;
    const video = videoRef.current;

    const startScanner = async () => {
      try {
        console.log("Initializing scanner with facingMode:", facingMode);
        
        const constraints = {
          video: { 
            facingMode: { ideal: facingMode },
            width: { ideal: 1280 },
            height: { ideal: 720 }
          }
        };

        // Use zxing's native constraint-based decoding
        await reader.decodeFromConstraints(constraints, video, (result, err) => {
          if (result) {
            const data = result.getText();
            console.log("Successfully scanned:", data);

            if (!data.startsWith('http') && /^[A-Z0-9]{2}-[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(data)) {
              const constructedUrl = `${window.location.origin}/scan/${data}`;
              onScan(constructedUrl);
            } else {
              onScan(data);
            }
          }

          // Capture the stream for the parent (Home.jsx uses it to stop manually if needed)
          if (video && video.srcObject && !streamRef.current) {
             streamRef.current = video.srcObject;
             setStreamParent(video.srcObject);
          }
        });

        console.log("Scanner initialized successfully.");
      } catch (err) {
        console.error("Scanner initialization failed:", err);
        if (onError) onError(err);
      }
    };

    const streamRef = { current: null };

    startScanner();

    return () => {
      reader.reset();
      if (video && video.srcObject) {
        const stream = video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
        video.srcObject = null;
      }
    };
  }, [facingMode, onScan, onError, setStreamParent]);

  return (
    <div className={styles.videoContainer}>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className={styles.videoElement}
      />
    </div>
  );
};

export default QrScanner;
